import { useMutation, useQuery } from '@tanstack/react-query';
import {
  createBooking,
  getBookingById,
  getBookingCheckout,
  getBookingDetail,
  getCheckoutBookingDetails,
  getVehicles,
  updateBookingAddons,
  updateBookingWithPromoCode,
} from 'api/bookingService';
import {
  BookingDetailResponse,
  UpdateDetailApiPayload,
} from 'types/BookingDetails';
import { CreateBookingPayload } from 'types/BookingCreate';
import { VehicleResponse } from 'types/products';

export function useGetVehicles(searchId: string) {
  return useQuery<VehicleResponse>({
    queryKey: ['getVehicles', searchId],
    queryFn: () => getVehicles(searchId),
    staleTime: 1000 * 60 * 5,
    enabled: !!searchId,
  });
}

export function useGetBookingDetail(id: string, vId: string) {
  return useQuery<BookingDetailResponse>({
    queryKey: ['getBookingDetail', id, vId],
    queryFn: () => getBookingDetail(id, vId),
    staleTime: 1000 * 60 * 5,
    enabled: !!id && !!vId,
  });
}

export function useGetBookingCheckout(id: string) {
  return useQuery<BookingDetailResponse>({
    queryKey: ['getBookingDetail', id],
    queryFn: () => getBookingCheckout(id),
    staleTime: 1000 * 60 * 5,
    enabled: !!id,
  });
}

export function usePutBookingAddons() {
  return useMutation({
    mutationFn: async (payload: UpdateDetailApiPayload) =>
      updateBookingAddons(payload),
  });
}

export function usePutBookingPromoCode() {
  return useMutation({
    mutationFn: async ({ id, code }: { id: string; code: string }) =>
      updateBookingWithPromoCode(id, code),
  });
}

export function useGetCheckoutBookingDetails(bookingDetailsId: string) {
  return useQuery<BookingDetailResponse>({
    queryKey: ['getCheckoutBookingDetails', bookingDetailsId],
    queryFn: async () => getCheckoutBookingDetails(bookingDetailsId),
    // staleTime: 1000 * 60 * 5,
    enabled: !!bookingDetailsId,
  });
}

export const useCreateBooking = () => {
  return useMutation({
    mutationFn: async (payload: CreateBookingPayload) => createBooking(payload),
  });
};

export const useGetBookingDetails = (bookingId: string) => {
  return useQuery({
    queryKey: ['getBookingCreatedDetails', bookingId],
    queryFn: async () => getBookingById(bookingId),
    enabled: bookingId !== '',
    staleTime: 60 * 60 * 1000,
  });
};
